'use strict';
var url = require('url');
var prependHttp = require('prepend-http');

module.exports = function (x) {
	var withProtocol = prependHttp(x);
	var parsed = url.parse(withProtocol);

	if (withProtocol !== x) {
		parsed.protocol = null;
	}

	return parsed;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/url-parse-lax/index.js
// module id = 53
// module chunks = 0